import React from 'react'
import * as S from './styled'
import { SummaryRow } from './SummaryRow'
import type { Props } from './types'

export const Summary = ({ small = false, children }: Props) => {
  return <S.Container $small={small}>{children}</S.Container>
}

Summary.Row = SummaryRow
